export default {
    name: 'Sabercroc',
    boostOneShot: {
        lv1: 1,
        lv2: 2,
        lv3: 12,
        lv4: NaN,
        lv5: NaN
    },
    oneShot: {
        lv1: 2,
        lv2: 5,
        lv3: 19,
        lv4: NaN,
        lv5: NaN
    },
    boostOneByOne: {
        lv1: 1,
        lv2: 1,
        lv3: NaN,
        lv4: NaN,
        lv5: NaN
    },
    oneByOne: {
        lv1: 1,
        lv2: 4,
        lv3: 10,
        lv4: 22,
        lv5: NaN
    }
};
